
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rooms/[id]",
      function () {
        return require("private-next-pages/rooms/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rooms/[id]"])
      });
    }
  